import type { TDialogProps } from '../components/TDialog/TDialog.types';
import { createApp, h } from 'vue';
import { TDialog } from '../components/TDialog';

interface DialogOptions extends TDialogProps {
  onCancel?: () => void;
  onConfirm?: () => void;
}

export const useDialog = () => {
  const open = ({ onCancel, onConfirm, ...props }: DialogOptions) => {
    const modalContainer = document.createElement('div');
    document.body.appendChild(modalContainer);
    const app = createApp({
      render() {
        return h(TDialog, {
          ...props,
          onConfirm: () => {
            onConfirm?.();
            app.unmount();
            modalContainer.remove();
          },
          onCancel: () => {
            onCancel?.();
            app.unmount();
            modalContainer.remove();
          },
          onClose: () => {
            onCancel?.();
            app.unmount();
            modalContainer.remove();
          },
        });
      },
    });
    app.mount(modalContainer);
  };

  return {
    open,
  };
};
